import React from "react";
import { useParams } from "react-router-dom";
import { useGetSingleUserPermissions } from "../../../../hooks/useGetSingleUserPermissions";
import DetailCard from "../../../../components/display/DetailCard";
import Skeletons from "../../../../components/loader/Skeletons";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../../utils/Functions";
import SimpleAlert from "../../../../components/display/SimpleAlert";
import PageContentWrapper from "../../../../components/wrappers/PageContentWrapper";

export default function UserGeneralInformationDisplay() {
  const { id } = useParams();
  const { data, loading, error } = useGetSingleUserPermissions(id);
  const { t } = useTranslation();
  function UserInformationRow({ userDetails }) {
    if (userDetails == null || userDetails == undefined) {
      return null;
    }
    const order = [
      "Firstname",
      "Lastname",
      "Username",
      "Role",
      "Email",
      "Phonenumber",
      "Subscribetoemails",
      "Oib",
      "Idcardnumber",
    ];

    const dontTranslate = ["Firstname", "Lastname", "Username"];

    const entries = Object.entries(userDetails)
      .filter(
        ([key, value]) =>
          order.includes(capitalizeFirstLetter(key)) && //Only inclue the tags that are in the order array
          value != null &&
          value != "" &&
          typeof value != "object"
      )
      .map(([key, value]) => ({
        title: capitalizeFirstLetter(key),
        value: dontTranslate.includes(capitalizeFirstLetter(key))
          ? String(value)
          : t(String(value)),
      }));

    // Ensure "Role" is included
    if (userDetails?.role) {
      entries.push({
        title: "Role",
        value: userDetails.role,
      });
    }

    // Sort based on order array
    const values = entries.sort((a, b) => {
      const indexA = order.indexOf(a.title);
      const indexB = order.indexOf(b.title);
      return indexA - indexB;
    });
    if (values.length == 0) {
      return null;
    }
    return <DetailCard valueArray={values} grid elevation={4} gridCount={3} />;
  }

  if (loading) {
    return (
      <PageContentWrapper>
        <Skeletons numOfSkeletons={6} />
      </PageContentWrapper>
    );
  } else if (error) {
    return (
      <SimpleAlert
        severity={"error"}
        message={"CouldntFetchUserInformationAtThisTime"}
      />
    );
  }

  return (
    <UserInformationRow
      userDetails={data?.user?.userDetails}
      key={"general-information-paper-view"}
    />
  );
}
